import { render, staticRenderFns } from "./UpdateCharge.vue?vue&type=template&id=13fc6336"
import script from "./UpdateCharge.vue?vue&type=script&lang=js"
export * from "./UpdateCharge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports